import { makeStyles } from '@material-ui/styles';

const makeIntroductionStyles = makeStyles({
  h1: {
    marginTop: '65px',
  },
});

export default makeIntroductionStyles;
